(function () {
'use strict';

angular
    .module('HRConfirmationsRoutes', [
        'HRConfirmationsControllers'
    ])
    .config(routeur);

    routeur.$inject = ['$stateProvider'];

    function routeur($stateProvider) {
        $stateProvider
             .state('HR.confirmations', {
                 url: '/Confirmation?r&g',
                 reloadOnSearch: false,
                 controller: 'HRConfirmationsController',
                 templateUrl: require('./confirmations.tpl.html'),
                 resolve: {
                     notConfirmedMatchings: ['employeeSyncService', function (service) {
                         return service.getNotConfirmedAndLastMatchingStagingRecords();
                     }],
                     latestClosedBatch: ['employeeSyncService', function (service) {
                         return service.getLatestClosedBatch();
                     }],
                     matchingRules: ['employeeSyncService', function (service) {
                         return service.getMatchingRules();
                     }]
                 }
             });
    }
})();